export const getBaseOptions = (options, type, defaultType) =>
  options[type] ?? options[defaultType];
